import { render } from "./Theme.vue?vue&type=template&id=ae132c70"
import script from "./Theme.vue?vue&type=script&lang=ts"
export * from "./Theme.vue?vue&type=script&lang=ts"
script.render = render

export default script